/** YouTube video id from a watch, share, or embed URL; undefined otherwise. */
export function youTubeId(url) {
  try {
    const { hostname, pathname, searchParams } = new URL(url);
    if (hostname === "youtu.be") return pathname.slice(1) || undefined;
    return (
      searchParams.get("v") ||
      pathname.split("/embed/")[1]?.split("?")[0] ||
      undefined
    );
  } catch {
    return undefined;
  }
}

export const isYouTubeUrl = (url) => /youtube|youtu.be/.test(url);
